import { Component, Input, ViewChild, ViewContainerRef, AfterViewInit, Type } from '@angular/core';

@Component({
  selector: 'app-tooltip-container',
  template: `
    <div class="tooltip-container">
      <ng-container #container></ng-container>
    </div>
    <div class="tooltip-arrow"></div>
  `,
  styleUrls: ['./tooltip-container.component.scss']
})
export class TooltipContainerComponent {
  @Input() component!: Type<any>;
  @Input() tooltipInputs: { [key: string]: any } = {};

  @ViewChild('container', { read: ViewContainerRef, static: true })
  viewContainerRef!: ViewContainerRef;

  constructor() {}

}
